import { cssColor } from "@fluentui/react";

/**
 * Turns a given hex color into an 'rgba' color with a 0.4 opacity
 * @param hexColor
 */
export const getModernUxDisabledColor = (hexColor: string): string => {
  const color = cssColor(hexColor);
  if (color) {
    return `rgba(${color.r}, ${color.g}, ${color.b}, 0.4)`;
  }
  // TODO: error if we couldn't convert?
  return hexColor;
};
